import React from 'react';
import moment from 'moment';
import Table from '../../utils/Table/Table';
import Axios from '../../../Axios';
import { useAdminContext } from '../../../context/AdminContext';

const ApprovedCourses = () => {
  const { adminConfig } = useAdminContext();

  const downloadCsv = async () => {
    try {
      const res = await Axios.get('/users_courses/payeds/list', adminConfig);
      const rows = Array.isArray(res.data) ? res.data : [];

      const headers = [
        'Сургалтын гарчиг',
        'Хэрэглэгчийн овог',
        'Хэрэглэгчийн нэр',
        'Утас',
        'И-мэйл',
        'Авсан огноо',
      ];

      const csvRows = rows.map((item) => [
        item?.course_title || '',
        item?.lastname || '',
        item?.firstname || '',
        item?.phone_number || '',
        item?.email || '',
        item?.payed_date
          ? moment(item.payed_date).format('YYYY/MM/DD HH:mm')
          : '',
      ]);

      const escapeCell = (value) => {
        const str = String(value ?? '');
        return `"${str.replace(/"/g, '""')}"`;
      };

      const csvContent = [headers, ...csvRows]
        .map((row) => row.map(escapeCell).join(','))
        .join('\n');

      const blob = new Blob([`\uFEFF${csvContent}`], {
        type: 'text/csv;charset=utf-8;',
      });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      link.href = url;
      link.download = `payed-courses-${moment().format('YYYYMMDD-HHmm')}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('CSV download error:', error);
      alert('Татаж авах үед алдаа гарлаа.');
    }
  };

  const downloadButton = (
    <button
      type='button'
      onClick={downloadCsv}
      className='inline-flex items-center rounded-lg border border-blue-600 bg-blue-600 px-6 py-3 text-base font-semibold text-white hover:bg-blue-700'
    >
      Бүгд татах
    </button>
  );

  const columns = [
    {
      Header: 'Сургалтын гарчиг',
      accessor: 'course_title',
    },
    {
      Header: 'Хэрэглэгчийн овог',
      accessor: 'lastname',
    },
    {
      Header: 'Хэрэглэгчийн нэр',
      accessor: 'firstname',
    },
    {
      Header: 'Утас',
      accessor: 'phone_number',
      disableSortBy: true,
      disableFilters: true,
    },
    {
      Header: 'И-мэйл',
      accessor: 'email',
      disableSortBy: true,
      disableFilters: true,
    },
    {
      Header: 'Авсан огноо',
      accessor: 'payed_date',
      disableFilters: true,
      Cell: ({ value }) => (
        <p style={{ width: 160 }}>
          {value && moment(value).isValid()
            ? moment(value).format('YYYY/MM/DD HH:mm')
            : '-'}
        </p>
      ),
    },
  ];

  return (
    <Table
      apiPath='/users_courses'
      apiSubPath='payeds'
      columns={columns}
      addButton={downloadButton}
      disableActions
    />
  );
};

export default ApprovedCourses;
